import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    accordion: {
      border: '1px solid #DDDDDD',
      borderRadius: 5,
      backgroundColor: '#ffffff',
      '&:before': {
        display: 'none',
      },
      '&.Mui-expanded': {
        margin: 0,
      },
    },
    accordionSummary: {
      margin: 0,
      color: '#001D29',
      '& .MuiAccordionSummary-content': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        margin: 0,
        padding: '1rem 0',
        '&.Mui-expanded': {
          margin: 0,
          paddingBottom: '0.8rem',
        },
      },
    },
    accordionDetails: {
      width: '100%',
      padding: '4px 16px 16px 16px',
    },
    projectName: {
      fontSize: '14px',
      marginBottom: '0.4rem',
    },
    regionName: {
      fontSize: '11px',
    },
    formContainer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '1.2rem',
    },
    autocomplete: {
      '& .MuiOutlinedInput-root': {
        borderRadius: '6px',
        backgroundColor: '#ffffff',
        '& .MuiOutlinedInput-input': {
          fontSize: '14px',
          fontWeight: 600,
          '&::placeholder': {
            opacity: 1,
          },
        },
      },
    },
    confirmButton: {
      margin: 0,
      width: '100%',
    },
  }),
)
